// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from "react-router-dom";
import logo from '@/assets/images/brion-tlogo.png';

export default function NavigationSub() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      //setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'About Us', href: '/' },
    { label: 'What We Do', href: '/' },
    { label: 'Certificates', href: '/' },
    { label: 'Blog', href: '/blog/assetclasses' },
    { label: 'Careers', href: '/' },

    { label: 'Contact', href: '/' },
  ];


  const navigate = useNavigate();

  // const handleNavigation = (e, href) => {
  //   e.preventDefault();

  //   navigate(href);

  //   setIsMobileMenuOpen(false);
  // };

  const handleNavigation = (e, href) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }

    navigate(href);
    setIsMobileMenuOpen(false);
  };


  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-background/95 backdrop-blur-md shadow-sm' : 'bg-primary'
      }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" onClick={(e) => handleNavigation(e, '/')} className="flex items-center">
            <img
              src={logo}
              alt="Brion Enterprises"
              className="h-10 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => handleNavigation(e, link.href)}
                className={`text-[1.2rem] transition-colors ${isScrolled
                  ? 'text-foreground/70 hover:text-foreground'
                  : 'text-white/80 hover:text-white'
                  }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className={`md:hidden ${!isScrolled && 'text-white hover:text-white hover:bg-white/10'}`}
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          >
            {isMobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background border-t border-border">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link, index) => (
              <a
                key={`${link.label}-${index}`}
                href={link.href}
                onClick={(e) => handleNavigation(e, link.href)}
                className="block text-sm font-medium text-foreground/70 hover:text-foreground transition-colors py-2"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}